const PRODUCT_TYPES_INELIGIBLE_FOR_MEMBERSHIP = [
  'Membership',
  'Donation',
  'FlaggedBook',
  'GiftCard',
  'Bookclub',
  'GiftSubscription',
];

/**
 * Automatically adds the membership product to a users cart if:
 * 1. They haven't removed it from their cart before
 * 2. The membership is not in their cart
 */

window.MembershipAutoAdd = async () => {
  await fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((response) => {
      window.Allstora.cart = response;

      /* Monthly */
      const membershipItem = window.Allstora.cart.items.filter(
        (item) => item.variant_id === window.Allstora.membership.variant_id
      );

      const membershipItemLine = window.Allstora.cart.items.findIndex(
        (item) => item.variant_id === window.Allstora.membership.variant_id
      );

      if (membershipItem.length && membershipItem[0].quantity > 1) {
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
          cartDrawerItems.updateQuantity(membershipItemLine + 1, 1);
        }
      }

      /* Yearly */
      const membershipYearlyItem = window.Allstora.cart.items.filter(
        (item) => item.variant_id === window.Allstora.membership_yearly.variant_id
      );

      const membershipYearlyItemLine = window.Allstora.cart.items.findIndex(
        (item) => item.variant_id === window.Allstora.membership_yearly.variant_id
      );

      if (membershipYearlyItem.length && membershipYearlyItem[0].quantity > 1) {
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
          cartDrawerItems.updateQuantity(membershipYearlyItemLine + 1, 1);
        }
      }
    });

  const cart = document.querySelector('cart-drawer');
  const cookieKey = 'membership-rejected';
  const membershipRejected = sessionStorage.getItem(cookieKey) === 'true' ? true : false;
  const membershipInCart =
    window.Allstora.cart.items.some((item) => item.id === window.Allstora.membership.variant_id) ||
    window.Allstora.cart.items.some((item) => item.id === window.Allstora.membership_yearly.variant_id);

  const bookclubInCart = window.Allstora.cart.items.some((item) => item.product_type === 'Bookclub');
  const giftSubscriptionInCart = window.Allstora.cart.items.some((item) => item.product_type === 'GiftSubscription');

  // Check if all items in the cart are ineligible for membership
  // Since the cart response doesn't include the product's tags,
  // we are using logic similar to the `DiscountIneligible` collection in Shopify
  const allIneligibleItems = window.Allstora.cart.items.every((item) =>
    PRODUCT_TYPES_INELIGIBLE_FOR_MEMBERSHIP.includes(item.product_type)
  );

  // Non-member = no `allstora-member` tag AND no `redeemed-new-member-discount` tag.
  // Logged-out visitors have `isMember`/`hasRedeemedNewMember` = false, so they qualify.
  const isNonMember = !window.Allstora.isMember && !window.Allstora.hasRedeemedNewMember;

  if (
    isNonMember &&
    !membershipRejected &&
    !membershipInCart &&
    window.Allstora.cart.item_count > 0 &&
    !bookclubInCart &&
    !giftSubscriptionInCart &&
    !allIneligibleItems
  ) {
    const formData = new FormData();
    formData.append('id', window.Allstora.membership.variant_id);
    formData.append('selling_plan', window.Allstora.membership.selling_plan_id);
    formData.append('quantity', 1);
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('[Membership auto-add error]: ', response.message);
        } else {
          sessionStorage.setItem(cookieKey, 'true');
          cart.renderContents(response, false);
        }
      });
  } else if (bookclubInCart && membershipInCart) {
    $('.cart-remove-button[data-variant-id=' + window.Allstora.membership.variant_id + ']').trigger('click');
    $('.cart-remove-button[data-variant-id=' + window.Allstora.membership_yearly.variant_id + ']').trigger('click');
  }
};

window.addEventListener('DOMContentLoaded', () => {
  window.MembershipAutoAdd();
});
